import "./App.css";
import Exterior from "./components/Exterior";
import Interior from "./components/Interior";
import { useState } from "react";

const models = [
  {
    key: "l9",
    name: "L9",
    colors: [
      {
        key: "black",
        name: "Черный",
        rims: [{ key: "black-gray-21", name: "Черный" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "silver",
        name: "Серебристый",
        rims: [{ key: "silver-gray-21", name: "Серебристый" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "blue",
        name: "Голубой",
        rims: [{ key: "black-gray-21", name: "Черный" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "gold",
        name: "Золотой",
        rims: [{ key: "silver-gray-21", name: "Серебристый" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "gray",
        name: "Серый",
        rims: [{ key: "silver-gray-21", name: "Серебристый" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "green",
        name: "Зеленый",
        rims: [{ key: "silver-gray-21", name: "Серебристый" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
      {
        key: "violet",
        name: "Фиолетовый",
        rims: [{ key: "silver-gray-21", name: "Серебристый" }],
        interiors: [
          { key: "brown", name: "Коричневый" },
          { key: "orange", name: "Оранжевый" },
          { key: "white", name: "Белый" },
        ],
      },
    ],
  },
];

export default function CarViewer() {
  const [widgetSelected, setWidgetSelected] = useState("exterior");
  const [colorSelected, setColor] = useState(models[0].colors[0]);

  function onChangeColorExterior(value) {
    setColor(value);
  }

  return (
    <>
      {/* <div className="header">AITO L7 Configurator Demo</div> */}

      <div className="configurator">
        <div className="configurator-navigation">
          <button
            className={`configurator-navigation__button ${
              widgetSelected === "exterior" &&
              "configurator-navigation__button--active"
            }`}
            onClick={() => setWidgetSelected("exterior")}
          >
            Экстерьер
          </button>

          <button
            className={`configurator-navigation__button ${
              widgetSelected === "interior" &&
              "configurator-navigation__button--active"
            }`}
            onClick={() => setWidgetSelected("interior")}
          >
            Интерьер
          </button>
        </div>

        {widgetSelected === "interior" ? (
          <Interior modelKey={models[0].key} color={colorSelected} />
        ) : (
          <Exterior
            model={models[0]}
            initColor={colorSelected}
            onChange={onChangeColorExterior}
          />
        )}
      </div>
    </>
  );
}
